module.exports = __webpack_public_path__ + "media/images/application/template/arrow-down-93fc3749c2a42db657a5d8deb12c07f5.png";